<script lang="ts">
  import '../app.css';
  import Header from '$components/shared/Header.svelte';
  import Footer from '$components/shared/Footer.svelte';
  import CommandPalette from '$components/shared/CommandPalette.svelte';
  import MobileMenu from '$components/shared/MobileMenu.svelte';
  import { page } from '$app/stores';
  import { onMount } from 'svelte';

  let { data, children } = $props();
  let mobileOpen = $state(false);

  // Set data-subject on <html> when URL has ?subject=... — drives --accent.
  $effect(() => {
    if (typeof document === 'undefined') return;
    const subject = $page.url.searchParams.get('subject');
    if (subject) {
      document.documentElement.setAttribute('data-subject', subject);
    }
  });

  // Restore persisted theme on mount (server HTML uses light by default).
  onMount(() => {
    const stored = localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark') {
      document.documentElement.setAttribute('data-theme', stored);
    }
  });
</script>

<a href="#main" class="skip-link">Негізгі мазмұнға өту</a>

<Header user={data?.user ?? null} onOpenMobile={() => (mobileOpen = true)} />
<MobileMenu bind:open={mobileOpen} user={data?.user ?? null} />
<CommandPalette />

<main id="main" class="main-content">
  {@render children?.()}
</main>

<Footer />

<style>
  .skip-link {
    position: absolute;
    top: -100px;
    left: 0;
    background: var(--color-bg);
    color: var(--color-fg);
    padding: var(--space-2) var(--space-4);
    border-radius: var(--radius-sm);
    z-index: var(--z-modal);
    font-size: var(--text-sm);
    font-weight: var(--fw-medium);
  }
  .skip-link:focus { top: var(--space-2); left: var(--space-2); }

  .main-content {
    min-height: calc(100vh - var(--header-h));
  }
</style>
